'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagImAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 28, height: 20, fill: "#D01129" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.0001 4.00004H19.3334L17.3334 8.6667L15.3334 7.33337C15.3334 7.33337 13.8815 3.88144 13.3334 3.33337C12.7853 2.7853 12.2296 3.2923 10.494 3.79838C8.75846 4.30446 8.69114 4.88496 8.01226 4.88496C7.73758 4.88496 6.86363 3.87234 6.37636 3.56986C5.65937 3.12477 5.40094 3.33337 5.57379 4.00004C5.6485 4.28819 6.2178 4.64382 6.57851 5.16101C7.05232 5.84036 7.33339 6.6667 7.33339 6.6667C7.33339 6.6667 7.98344 6.05912 8.33323 5.95918C8.86403 5.80753 9.46188 6.06774 10.1622 5.95918C11.0527 5.82114 12.0001 5.33337 12.0001 5.33337L12.2318 7.87601C12.2318 7.87601 9.06028 10.8232 9.33339 12C9.6065 13.1769 12.6253 14.6219 13.3334 15.653C14.0415 16.6841 12.9125 17.0685 12.9125 17.5637C12.9125 18.0589 12.7948 18.7187 13.3334 18.5205C13.872 18.3224 13.9372 17.4638 14.4312 16.6841C14.7711 16.1477 15.0447 15.865 15.0917 15.653C15.207 15.1328 13.7215 13.7673 12.9125 12.7994C12.5271 12.3383 11.7504 11.7128 11.7504 11.7128L14.0415 10C14.0415 10 17.9963 11.6335 18.8884 11.0892C19.7805 10.5449 20.0001 5.33337 20.0001 5.33337L22.7496 4.6667L22.0001 4.00004Z",
          fill: "url(#paint0_linear_304_2334)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.3332 15.3333C14.965 15.3333 14.6665 15.0348 14.6665 14.6666C14.6665 14.2985 14.965 14 15.3332 14C15.7014 14 15.9999 14.2985 15.9999 14.6666C15.9999 15.0348 15.7014 15.3333 15.3332 15.3333ZM17.9999 4.66665C17.6317 4.66665 17.3332 4.36817 17.3332 3.99998C17.3332 3.63179 17.6317 3.33331 17.9999 3.33331C18.3681 3.33331 18.6665 3.63179 18.6665 3.99998C18.6665 4.36817 18.3681 4.66665 17.9999 4.66665ZM17.9999 9.99998C17.6317 9.99998 17.3332 9.7015 17.3332 9.33331C17.3332 8.96512 17.6317 8.66665 17.9999 8.66665C18.3681 8.66665 18.6665 8.96512 18.6665 9.33331C18.6665 9.7015 18.3681 9.99998 17.9999 9.99998ZM9.99988 12.6666C9.63169 12.6666 9.33322 12.3682 9.33322 12C9.33322 11.6318 9.63169 11.3333 9.99988 11.3333C10.3681 11.3333 10.6665 11.6318 10.6665 12C10.6665 12.3682 10.3681 12.6666 9.99988 12.6666ZM12.6665 4.66665C12.2984 4.66665 11.9999 4.36817 11.9999 3.99998C11.9999 3.63179 12.2984 3.33331 12.6665 3.33331C13.0347 3.33331 13.3332 3.63179 13.3332 3.99998C13.3332 4.36817 13.0347 4.66665 12.6665 4.66665ZM13.9999 9.99998C13.6317 9.99998 13.3332 9.40303 13.3332 8.66665C13.3332 7.93027 13.6317 7.33331 13.9999 7.33331C14.3681 7.33331 14.6665 7.93027 14.6665 8.66665C14.6665 9.40303 14.3681 9.99998 13.9999 9.99998ZM7.33322 7.33331C6.96503 7.33331 6.66655 7.03484 6.66655 6.66665C6.66655 6.29846 6.96503 5.99998 7.33322 5.99998C7.70141 5.99998 7.99988 6.29846 7.99988 6.66665C7.99988 7.03484 7.70141 7.33331 7.33322 7.33331Z",
          fill: "url(#paint1_linear_304_2334)"
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint0_linear_304_2334",
            x1: 14.1358,
            y1: 3.09636,
            x2: 14.1358,
            y2: 18.5566,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "white" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F0F0F0" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint1_linear_304_2334",
            x1: 12.6665,
            y1: 3.33331,
            x2: 12.6665,
            y2: 15.3333,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F8DD4E" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F9DA38" })
            ]
          }
        )
      ] })
    ]
  }
);
const VpFlagImAsset = forwardRef(FlagImAsset);

export { VpFlagImAsset as default };
